import { render, staticRenderFns } from "./FundamentalCoverPage1.vue?vue&type=template&id=21449212&"
import script from "./FundamentalCoverPage1.vue?vue&type=script&lang=ts&"
export * from "./FundamentalCoverPage1.vue?vue&type=script&lang=ts&"
import style0 from "./FundamentalCoverPage1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports